export const PERSONALIZATION_NICKNAME_MAX_CHARS = 40;
export const PERSONALIZATION_CUSTOM_INSTRUCTIONS_MAX_CHARS = 1000;

export function capNicknameInput(value: unknown): string {
  if (typeof value !== "string") return "";
  return value.slice(0, PERSONALIZATION_NICKNAME_MAX_CHARS);
}

export function capCustomInstructionsInput(value: unknown): string {
  if (typeof value !== "string") return "";
  return value.slice(0, PERSONALIZATION_CUSTOM_INSTRUCTIONS_MAX_CHARS);
}

export function normalizeNickname(value: unknown): string {
  if (typeof value !== "string") return "";
  return value.replace(/\s+/g, " ").trim().slice(0, PERSONALIZATION_NICKNAME_MAX_CHARS);
}

export function normalizeCustomInstructions(value: unknown): string {
  if (typeof value !== "string") return "";
  return value.trim().slice(0, PERSONALIZATION_CUSTOM_INSTRUCTIONS_MAX_CHARS);
}
